/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { deleteData, fetchData, postData } from '@jda/lui-portal-utilities';
import { getAuthToken } from '../auth/authProvider';
import { IPermission } from '../models/Permission/PermissionContract';
import { createRequestObject, getAPIMUrl } from '../utility/commonUtility';

const { CLIENT_SERVICE_V1_URL } = window['env'];
export const getAllPermissions = async () => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/permissions`;

  return fetchData<IPermission[]>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const savePermissionOfRole = async (roleId: number, data: { permissionId: number }) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/roles/${roleId}/permissions`;
  return postData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deletePermissionForRole = async (id: number, permissionId: string | number) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/roles/${id}/permissions/${permissionId}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getPermissionsForRole = async (roleId: number, locationName?: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/roles/${roleId}/permissions`;
  return fetchData<IPermission[]>(
    createRequestObject(apiURL),
    locationName
      ? {
          headers: {
            'LOCATION-CONTEXT': locationName
          }
        }
      : getAuthToken
  )
    .then(appsResponse => {
      return appsResponse;
    })
    .catch(error => {
      throw error;
    });
};
